import { getApiUrl, type MarketResponseDto } from "Infrastructure/Api/Api";
import { FadeInTopAnimation } from "Shared/Components/Animation/In/FadeInTopAnimation";
import { BlankCard } from "Shared/Components/Cards/BlankCard";
import { OutlinedFlag } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { motion } from "motion/react";
import type { FC } from "react";

type MarketCardProps = {
	market: MarketResponseDto;
	index: number;
	onClick: () => void;
};

export const MarketSelectCard: FC<MarketCardProps> = (props) => {
	const { market, index, onClick } = props;

	return (
		<FadeInTopAnimation delay={index * 0.15}>
			<motion.div
				initial={{ y: 0, opacity: 1 }}
				transition={{
					duration: 0.15,
				}}
				whileHover={{
					scale: 1.05,
					transition: { duration: 0.15 },
				}}
				whileTap={{ scale: 0.98 }}
			>
				<Box maxWidth="300px" sx={{ cursor: "pointer" }} onClick={onClick}>
					<BlankCard>
						<Stack
							justifyContent="center"
							alignItems="center"
							padding="8px 12px"
						>
							<Box width="60px" height="60px" padding="6px">
								{market.iconPath ? (
									<img
										src={`${getApiUrl()}${market.iconPath}`}
										alt={market.country}
										width="100%"
										height="100%"
									/>
								) : (
									<OutlinedFlag fontSize="large" />
								)}
							</Box>
							<Typography
								mt={1}
								variant="h6"
								fontWeight={600}
								textAlign="center"
							>
								{market.name}
							</Typography>
						</Stack>
					</BlankCard>
				</Box>
			</motion.div>
		</FadeInTopAnimation>
	);
};
